var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg02LogoMenuCuadrado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1D4ED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#38BDF8"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 48,
    fill: "#F8FAFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50,80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 40h130c14 0 20 6 30 18h120c18 0 28 10 28 28v120c0 18-10 28-28 28H60c-18 0-28-10-28-28V68c0-18 10-28 28-28z",
    fill: "url(#g1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 150,
    r: 58,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 150,
    r: 36,
    fill: "#0F172A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 138,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 190l40 40",
    stroke: "#2563EB",
    strokeWidth: 16,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 108h50M0 148h35M0 188h50",
    stroke: "#38BDF8",
    strokeWidth: 14,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02LogoMenuCuadrado);
export default __webpack_public_path__ + "static/media/02-logo-menu-cuadrado.49484b541274303e31d067027f4908ba.svg";
export { ForwardRef as ReactComponent };